export default "__VITE_ASSET__CNSG6KPH__"